import Vue from "vue";

const state = {
  compare: false,
  viewType: "mapView",
  modelType: "climate",
  variable1_display_name: undefined,
  variable2_display_name: undefined,
  variable1_raster_function: undefined,
  variable2_raster_function: undefined,
  variable1_unit: undefined,
  variable2_unit: undefined,
  variable1_chart_color: undefined,
  raster_name_1: undefined,
  raster_name_2: undefined,
  base1: "HU",
  base2: "HU",
  dateRangeStart1: 1971,
  dateRangeStart2: 1971,
  variable_1_notation: undefined,
  variable_2_notation: undefined,
  idoszak: "alma",
  idoszak1: undefined,
  idoszak2: undefined,
  felbontas: "HUM000",
  baseCitySelect1: "BP",
  baseCitySelect2: "BP",
  outPdfLink: undefined,
  reEnablePrint: function () {},
  processType1: undefined,
  processType2: undefined,
  downloadChartF: function () {},
};

const getters = {};

const mutations = {};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
